export default function ClaudeLogo({ className = "h-8 w-8" }) {
  return (
    <svg viewBox="0 0 100 100" className={className} aria-hidden="true">
      <g fill="#CC785C">
        {Array.from({ length: 12 }).map((_, i) => {
          const angle = (i * 30 * Math.PI) / 180;
          const cx = 50 + 34 * Math.cos(angle);
          const cy = 50 + 34 * Math.sin(angle);
          return (
            <rect
              key={i}
              x={cx - 4}
              y={cy - 11}
              width="8"
              height="22"
              rx="4"
              transform={`rotate(${i * 30 + 90} ${cx} ${cy})`}
            />
          );
        })}
      </g>
    </svg>
  );
}
